module.exports = __webpack_public_path__ + "img/mtn.c2d52cb0.png";